<template>
  <div class="fullwidth-box infinite-list-wrapper" ref="chatBox" :class="isPopupChat ? 'fullwidth-box-popup' : ''">
    <div class="frame-item-filter-2022" style="padding: 0 10px">
      <el-input
        size="mini"
        placeholder="Nhập SĐT, MBG, MVĐ, MB"
        @keyup.enter.native="searchQ()"
        clearable
        v-model="filter.keyword">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="d-flex align-items-center filter-left justify-content-between">
      <div class="d-flex align-items-center" style="width: 30%">
        <el-button @click="cancelUnread()" size="mini" class="w100pt">Tất cả <span v-if="total_all_chat > 0"> ({{ total_all_chat | vnd2 }})</span></el-button>
      </div>
      <div class="d-flex align-items-center ml-1" style="width: 35%">
        <el-button @click="switchUnread()" size="mini" class="w100pt">Chưa đọc <span v-if="total_unseen > 0">({{ total_unseen | vnd2 }})</span></el-button>
        <i @click="cancelUnread()" style="cursor: pointer; padding-left: 5px" class="el-icon-circle-close" v-if="filter.unseen == 1"></i>
      </div>
      <div class="frame-item-filter-2022 ml-1 date-editor">
        <el-date-picker
          v-model="filter.date"
          type="date"
          placeholder="Ngày"
          class="frame-date-common-2022 v2"
          size="mini"
          clearable
          popper-class="frame-date-popper-common-2022"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          @change="searchQ()"
        >
        </el-date-picker>
      </div>
    </div>
    <!--    // phần ds chat -->
    <div v-loading="loading">
      <div v-for="item in listConversation" :key="item.id">
        <div class="d-flex align-items-center box-item-chat" @click="showDetail(item)" :class="item.id == boxActive.id ? 'isActiveBox' : ''">
          <div class="image-avatar">
            <img src="@/static/icon/chat/noa.png" alt="" :class="item.id == boxActive.id ? 'isActiveRadius' : ''">
          </div>
          <div class="info-item">
            <div class="d-flex align-items-center justify-content-between pb-1">
              <div class="d-flex align-items-center" v-if="isXNK">
                <div class="text-ellipsis" style="font-weight: 700">
                  <div class="d-flex align-items-center">
                    <span class="name">{{ item.user_name }}</span>
                  </div>
                  <span style="font-size: 11px;  padding-top: 5px; display: block">
                    KH:{{ item.customer_name }} - {{ item.customer_phone }}
                  </span>
                </div>
              </div>
              <div v-else>
                <span class="name">MBG: {{ item.quote_code }}</span>
              </div>
              <div style="text-align: right">
                <div class="name mBg">MBG: {{ item.quote_code }}</div>
                <span  class="date">{{ formatDateTimeVN(item.created_at) | vnTimeAgo }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center pb-1 justify-content-between" style="font-size: 12px">
              <span
                class="dess">{{ handleLastMessage(item) }}</span>
              <span class="number-chat" v-if="item.total_unseen > 0">{{ item.total_unseen }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="listConversation.length == 0 && this.loading == false" class="no-data">
        <span>Không có dữ liệu</span>
      </div>
      <infinite-loading @infinite="infiniteHandler"></infinite-loading>

    </div>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import axios from "axios";
  import {mapGetters} from "vuex";
  export default {
    name: "ListChat",
    metaInfo() {
      return {
        title: "",
      };
    },
    props: {
      messageLast: Object
    },
    components: {
      InfiniteLoading,
    },
    data() {
      return {
        canSubmit: true,
        loading: false,
        filter: {
          q: "",
          unseen: 0,
          date: "",
          type: "",
          user_id: "",
          page: 1,
          per_page: 10,
          keyword: '',
          code: '',
        },
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          last_page: 0,
        },
        listConversation: [],
        boxActive: {},

        total_unseen: 0,
        total_all_chat: 0,
      };
    },
    computed: {
      ...mapGetters("account", ["accountInfo", "language"]),
      isXNK () {
        return this.accountInfo.roles[0].description == 'XNK';
      },
      isPopupChat () {
        return this.path !== 'chat-list'
      },
    },
    mounted() {
      this.fetchConversation();
    },
    methods: {
      searchQ () {
        this.filter.page = 1;
        this.fetchConversation();
      },
      // chua doc
      switchUnread () {
        this.filter.page = 1
        this.filter.unseen = 1
        this.fetchConversation();
      },
      cancelUnread () {
        this.filter.page = 1
        this.filter.unseen = 0
        this.fetchConversation();
      },
      // xem chi tiet chat
      showDetail (item) {
        // Set lại số lượng chat chưa đọc
        item.total_unseen = 0
        // Cài đặt
        this.boxActive = item;
        this.$emit('showDetail', item);
      },
      // ds
      infiniteHandler($state) {
        this.fetchConversation($state)
      },
      fetchConversation($state = '') {
        // this.loading = true;
        let filter = {
          unseen: this.filter.unseen,
          keyword: this.filter.keyword,
          type: this.filter.type,
          date: this.filter.date,
          page: this.filter.page,
          per_page: this.filter.per_page,
        }
        axios.get("chat", {params: filter}).then((response) => {
          // this.loading = false;
          switch (response.code) {
            case 200:

              var dataItems = response.data.items;
              var dataPagination = response.data.pagination;
              this.total_unseen = response.data.total_unseen;
              this.total_all_chat = response.data.total_all_chat;


              if ($state) {
                if (this.filter.page > 1) {
                  this.listConversation.push(...dataItems);
                }
                this.filter.page += 1;
              } else {
                this.listConversation = dataItems;
              }

              this.pagination.total = dataPagination.total;
              this.pagination.per_page = dataPagination.per_page;

              if ($state) {
                if (this.filter.page > dataPagination.total_pages) {
                  $state.complete();
                } else {
                  $state.loaded();
                }
              }

              if (this.$route.query.chat_id) {
                setTimeout(() => {
                  this.detailConversation();
                }, 1000);
              }

              // Nếu không có gì
              /*if (dataItems.length == 0 && this.filter.q != "") {
                this.checkStoreSeachNull();
              }*/

              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },
      detailConversation() {
        const item = this.listConversation.find(
          i => i.id == this.$route.query.chat_id
        );

        if (item) {
          this.boxActive = item;
          this.$emit('showDetail', item);
        }

        if (Object.keys(this.$route.query).length) {
          this.$router.replace({
            path: this.$route.path,
            query: {}
          });
        }
      },

      formatDateTimeVN(dateStr) {
        if (!dateStr) return ''
        const parts = dateStr.split(' ')
        if (parts.length !== 2) return dateStr
        const [date, time] = parts
        const dateParts = date.split('-')
        if (dateParts.length !== 3) return dateStr
        const [day, month, year] = dateParts
        if (!day || !month || !year || year.length !== 4) return dateStr
        return `${year}-${month}-${day} ${time}`
      },
      addDataLast () {
        this.listConversation.forEach((item) => {
          if (item.id == this.messageLast.id) {
            // Xóa phần tử khỏi vị trí hiện tại và thêm vào đầu mảng
            this.listConversation = this.listConversation.filter(i => i.id !== this.messageLast.id);
            this.listConversation.unshift(item);
            this.boxActive = item;
            item.last_message = this.messageLast.content;
            item.created_at = this.messageLast.time_sent;
          }
        })
      },
      // xử lý lại tin nhắn cuối cùng
      handleLastMessage (item) {
        let contentCheck = ""
        let type = item.type_last_message;
        let user_name = item.user_name_last_message
        if (type == 1) {
          contentCheck = user_name  + " đã gửi 1 ảnh"
        }
        else if (type == 2) {
          contentCheck = user_name  + " đã gửi 1 video"
        }
        else if (type == 3) {
          contentCheck = user_name  + " đã gửi 1 file"
        }
        else if (type == 4) {
          contentCheck = user_name  + " đã gửi 1 sản phẩm"
        }
        else {
          contentCheck = item.last_message
        }
        return contentCheck
      }
    },
    watch: {
      messageLast: {
        immediate: true,
        handler() {
          this.addDataLast();
        }
      },
    },
    sockets: {
      "receive-message-to-conversation": function (data) {
        if(data) {
          this.searchQ();
        }
      },
    }
  };
</script>

<style lang="css" scoped>
  .filter-left {
    padding: 10px;
  }
  .status_order {
    padding: 2px 5px;
    font-size: 11px;
    color: #ffffff;
    margin-left: 5px;
    border-radius: 4px;
  }
  .fullwidth-box-popup {
    height: 570px !important;
  }
  .fullwidth-box {
    height: calc(100vh - 115px);
    overflow-y: scroll;
  }
  .fullwidth-box::-webkit-scrollbar {
    width: 8px;
  }
  .fullwidth-box::-webkit-scrollbar-track {
    border: none;
    background: transparent;
  }
  .box-item-chat {
    background: #ffffff;
    padding: 15px 10px 15px 10px;
    /*border-top: 1px solid #C4C4C440;*/
    border-bottom: 1px solid #C4C4C440;
    cursor: pointer;
  }
  .box-item-chat:hover {
    background: #C4C4C436;
    border-radius: 5px;
  }

  .isActiveBox {
    background: #C4C4C436;
  }

  .isActiveRadius {
    border: 2px solid #0F56B3 !important;
  }

  .image-avatar {
    margin-right: 10px;
  }

  .image-avatar img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid transparent;
    object-fit: cover;
  }

  .info-item {
    width: 80%;
  }

  .info-item .name {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    line-height: 16px;
  }

  .info-item .date {
    font-size: 12px;
    color: #C4C4C4;
    line-height: 16px;

  }

  .info-item .dess {
    display: -webkit-box;
    line-height: 20px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #606266;
  }

  .info-item .number-chat {
    background: #0F56B3;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 5px;
    border-radius: 4px;
    margin-left: 5px;
  }

  .box-item-order {
    font-size: 12px;
  }

  .box-item-order .code-po {
    padding: 2px 5px;
    background: #399CFF;
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
  }
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
  }
  .w100pt {
    width: 100%;
  }
  /*.text-ellipsis {
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }*/
  .mBg {
    background: rgb(12, 145, 223);
    color: rgb(255, 255, 255);
    padding: 5px;
    border-radius: 5px;
    font-size: 10px !important;
    max-width: 130px;
    text-align: center;
  }
</style>
<style>
  .date-editor .el-input {
    width: 180px !important;
  }
  .el-input__inner::placeholder {
    color: #606266 !important;
  }
</style>
